export default "__VITE_ASSET__xnDRo7Xh__"